import { composeIO } from 'react-compose-io'
import { inadimplenciaAnomaliaIO } from './InadimplenciaAnomalia.IO'
import { InadimplenciaAnomaliaView } from './InadimplenciaAnomalia.View'

export const InadimplenciaAnomalia = composeIO(InadimplenciaAnomaliaView, inadimplenciaAnomaliaIO)
